var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "amimoc.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "15.00",
            "price_rule_id": 1235175080154,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "NzMxMDk="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "15%",
            "refer_background_color": "#597955",
            "refer_text_color": "#ffffff",
            "web_position": "left-bottom",
            "mobile_position": "left-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Donnez 15% et Recevez 15% en r\u00e9compense",
            "popup_description": "Offrez \u00e0 vos ami.e.s une remise de 15% sur BoutiqueMartino.com! Une fois qu'il.elle aura effectu\u00e9 un achat, vous recevrez \u00e9galement 15% sur sa premi\u00e8re commande r\u00e9f\u00e9r\u00e9e! \r\nCette r\u00e9compense accumulable peut \u00eatre \u00e9chang\u00e9e contre des Martino Dollars pour votre prochain achat sur BoutiqueMartino.com",
            "button_text_get_invite": "Obtenez votre lien",
            "button_copy_invite": "Copiez votre lien",
            "popup_background_color": "#597955",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "Rabais de 15% \/ 15% Discount",
            "shop_description": "F\u00e9licitations! Votre ami.e vous a offert un rabais de 15%. Le code sera automatiquement appliqu\u00e9 \u00e0 la page de paiement. \/ Congrats! Your friend offered you a 15% discount. The code will automatically be applied to the checkout page.",
            "shop_button_text": "Magasinez \/ Shop Now",
            "shop_background_color": "#597955",
            "shop_text_color": "#ffffff"
        }
    }
}